import StrUtil from "@/utils/StrUtil";

export default {
  getToken() {
    return localStorage.getItem('token')
  },
  setToken(token: string) {
    localStorage.setItem('token', token);
  },
  exist() {
    return StrUtil.isNotBlank(this.getToken())
  },
  getBearerToken() {
    return 'Bearer ' + this.getToken()
  }
}